import React, { useState, useEffect, useContext, useRef, useCallback } from 'react';
import axios from 'axios';
import { useNavigate, useParams } from 'react-router-dom';
import AuthContext from '../../context/AuthContext';
import { FaCopy, FaUserSlash, FaUserPlus, FaMinus} from 'react-icons/fa'; 
import socket, {addJoinEvent, removeJoinEvent} from '../../socket';

import SendSiteFeedback from '../feedback/SendSiteFeedback';
import AdminGlobalScenarios from './AdminGlobalScenarios';
import AdminStatisticsPage from './AdminStatisticsPage';
import AdminUserPage from './AdminUserPage';
import AdminTopBar from './AdminTopBar';
import AdminTagsManagement from './AdminTagsManagement';

const AdminPage = ({ isAdmin }) => {
    const [activeTab, setActiveTab] = useState('Scenarios');
    const { userId, user } = useContext(AuthContext);
    const [userCount, setUserCount] = useState(0);

    const updateUserCount = useCallback((data) => {
        setUserCount(data.userCount);
    }, [setUserCount])

    useEffect(() => {
        if (!socket) {
            return;
        }

        const eventHandlers = {
            'currentUserCount': updateUserCount
        };

        Object.entries(eventHandlers).forEach(([event, handler]) => {
            socket.on(event, handler);
        });

        // The server checks the tier on the handshake token, not this payload, so
        // `forUserId` holds the join until the connection is bound to that user.
        addJoinEvent('joinedAdminRoom', { userId }, undefined, { forUserId: userId });
        
        return () => {
            Object.entries(eventHandlers).forEach(([event, handler]) => {
                socket.off(event, handler);
            });
            removeJoinEvent('joinedAdminRoom');
            socket.emit('leaveAdminRoom');
        }
    }, [socket, user])
    return (
        <>
        <AdminTopBar activeTab={activeTab} setActiveTab={setActiveTab}/>
        <div>
            {activeTab === 'Scenarios' && <AdminGlobalScenarios setActiveTab={setActiveTab}/>}
            {activeTab === 'Tags' && <AdminTagsManagement setActiveTab={setActiveTab}/>}
            {activeTab === 'Site Feedback' && <SendSiteFeedback isAdmin={true}/>}
            {activeTab === 'Users' && <AdminUserPage setActiveTab={setActiveTab} />}
            {activeTab === 'Statistics' && <AdminStatisticsPage setActiveTab={setActiveTab} userCount = {userCount} />}
        </div>
        </>
    );
};

export default AdminPage


//PLAN:::::::

// Admin joins socket room AdminPage
    // Will get emissions of user count when users join and leave
    // Live user creation is unnecessary but can be added if we want
    // We will need some kind of universal socket so if an admin bans a user it auto-updates without needing a refresh

// Statistics
    // Cron job that will save max users per hour (Store in database for 30 days) 
    //                                  so we will have 720 integers being stored?
    // other stats?

//Scenarios
    //Do we want it to have the same display as the landing page or a table view of all the scenarios?
    // what abilities will admins have (deletion only?) deletion, hiding
    // live updates for this too

// Users

